module.exports = __webpack_public_path__ + "img/image23.8ba4efc7.jpg";